module.exports = __webpack_public_path__ + "img/tarj2-2.88da8a91.png";